import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const testimonialsContent = {
  title: 'Lo que dicen colegas que ya lo usan',
  testimonials: [{
    name: 'Lic. Romina T.',
    role: 'Estimuladora Temprana',
    quote: 'Me cambió la práctica. Las fichas de observación y los registros evolutivos me ahorraron horas. Ahora llego a cada sesión con todo el material clínico preparado.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
  }, {
    name: 'Lic. Laura G.',
    role: 'Psicopedagoga - Atención Temprana',
    quote: 'El TOMO de Integración Sensorial me dio un marco clarísimo para intervenir. Los chicos se enganchan con los materiales visuales y las familias entienden mucho mejor el proceso.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop'
  }, {
    name: 'Lic. Martín G.',
    role: 'Terapista Ocupacional Infantil',
    quote: 'La sección de Regulación Emocional y Conductual es oro puro. La inversión se recupera con las primeras semanas y la calidad del material eleva muchísimo mi servicio.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&auto=format&fit=crop'
  }]
};
export function Testimonials() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-223">
      <div className="max-w-6xl mx-auto" data-id="element-224">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif text-center mb-16 text-brand-light" data-id="element-225">
          {testimonialsContent.title}
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-226">
          {testimonialsContent.testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-card border border-brand-cardBorder rounded-2xl p-8 flex flex-col" data-id="element-227">
              <div className="flex items-center gap-1 text-yellow-500 mb-6" data-id="element-228">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-229" />)}
              </div>

              <p className="text-brand-light/90 font-sans italic mb-8 flex-grow" data-id="element-230">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-231">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border border-brand-cardBorder" data-id="element-232" />
                <div data-id="element-233">
                  <h4 className="font-serif font-semibold text-brand-light" data-id="element-234">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-brand-light/60 font-sans" data-id="element-235">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}